/* eslint-disable consistent-return */
import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { Button, Col, Container, Row } from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import { newPassword } from '../../../actions/login';
import TextViewer from '../../common/editor/text-viewer';
import PasswordMaskInput from '../../common/form/elements/password-mask-input';
import './style.css';
import { USER_TYPE_REP, USER_TYPE_RETAILER, USER_TYPE_ADMIN } from '../../../data/userTypes';
import IgniteUkLogo from '../../../assets/img/ignite_logo_black.png';

class NewPasswordForm extends Component {
  handleSubmit = (payLoad) => {
    const { dispatch, area, resetType } = this.props;

    const redirectUrl = {
      [USER_TYPE_RETAILER]: '/my-profile',
      [USER_TYPE_REP]: '/team',
      [USER_TYPE_ADMIN]: '/admin',
    };

    dispatch(actions.submitFields('deep.resetPW.step4', newPassword(payLoad, resetType, redirectUrl[area])
      .catch((error) => {
        dispatch({
          type: 'NEW_PASSWORD_REJECTED',
          payLoad: error.response.data
        });

        const { errors } = error.response.data;
        dispatch(actions.change('deep.resetPW.step4.password', '', { silent: true }));
        dispatch(actions.change('deep.resetPW.step4.password_confirmation', '', { silent: true }));
        if (Object.prototype.toString.call(errors) === '[object Array]') {
          // ....
        } else {
          return Promise.reject(errors.user);
        }
      })));
  };
  resetErrors = () => {
    this.props.dispatch(actions.resetErrors('deep.resetPW.step4'));
  };

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;
    dispatch(actions.reset('deep.resetPW.step4'));
  }

  render() {
    return (
      <Container fluid className="new-password">
        <Col lg={12}>
          <Row>
            <img src={IgniteUkLogo} alt="Ignite UK" />
            <PageTitle>
              Please create a new password
            </PageTitle>
            <hr className="invisible new-password-hr"/>
          </Row>
          <span className="new-password-editable">
            <TextViewer pageSlug='set-new-password' />
          </span>
          <Row className="new-password-helper">
            Your new password must be a minimum of 8 characters and contain one uppercase, one lowercase,
            {' '}
            {this.props.area === USER_TYPE_RETAILER ? 'and one number' : 'one number and one symbol (e.g. @*&/).'}
          </Row>
          <Row>
            <Form
              className="new-password-form"
              model="deep.resetPW.step4"
              onChange={() => this.resetErrors()}
              onSubmit={values => this.handleSubmit(values)}
            >
              <Errors className="errors" model="deep.resetPW.step4" />

              <label className="new-password-form-label" htmlFor=".password">
                Password
              </label>
              <Control
                className="form-control"
                component={PasswordMaskInput}
                model=".password"
              />
              <Errors
                className="errors"
                model=".password"
                show={{
                  touched: true,
                  focus: false
                }}
              />

              <label className="new-password-form-label" htmlFor=".password_confirmation">
                Confirm password
              </label>
              <Control
                className="form-control"
                component={PasswordMaskInput}
                model=".password_confirmation"
              />
              <Errors
                className="errors"
                model=".password_confirmation"
                show={{
                  touched: true,
                  focus: false
                }}
              />
              <br />
              <Button
                id="new-password-form-button"
                className="red-btn float-end new-password-form-btn"
                disabled={!this.props.formValid}
                type="submit"
              >
                Change my password
              </Button>
            </Form>
          </Row>
        </Col>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.resetPW.step4.$form.valid
});

export default connect(mapStateToProps)(NewPasswordForm);
